module.exports = __webpack_public_path__ + "img/frase_balao_2.2a1eb584.svg";